<div class="main-content">
  <div class="main-header">
    <a [routerLink]="['/cloud-extract']" style="cursor: pointer;"><img
      src="./assets/Expand-Column-left.svg" alt="Image 1" class="r-m20" style="vertical-align: middle;" /></a>
    Extract Cloud Configurations <div class="tooltip"><img src="./assets/Info.svg"
        alt="Image 1" /><span class="tooltiptext">Cloud Extract feature allows us to select and extract multiple
        configurations across modules
        from a preconfigured cloud instance, provides detailed reporting. These extracts can in turn be loaded target
        instance
        using Cloud Load feature thus enabling cloud to cloud configuration migration.</span></div>
  </div>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
